import * as enumModels from '../Models/EnumModels';

export class UIState {
  public SelectedModule: enumModels.Modules;
  public LeftExpanded: boolean = false;
  public SreenName: string = null;
}

export class UserState {
  public UnReadMessageCount: number = 0;
}

export class MultilingualLabel {
  public Tag: string;
  public Label: string;
}
export class ModuleMultilingualLabels {
  public ModuleCode: string;
  public Labels: Array<MultilingualLabel> = [];
}
